import { Consent } from '@/components/Consent';
import { Edge } from '@/components/Edge';
import { StateProviders } from '@/components/StateProviders';
import { Tracking } from '@/components/Tracking';
import { initAllerUserConsentQueue } from '@/utils/initAllerUserConsentQueue';
import { withCookiesInterceptor } from '@/utils/withCookiesInterceptor';
import { withDevelopmentConsentCookie } from '@/utils/withDevelopmentConsentCookie';
import { withFetchInterceptor } from '@/utils/withFetchInterceptor';
import { GridOverlay } from 'base/components/GridOverlay';
import { with410 } from 'base/with410';
import EmbedLogin from 'lib/AlltIdAuth';

import type { AppProps } from 'next/app';
import '../base/css/styles.css';
import { useUserMigration } from '@/hooks/useUserMigration';

withCookiesInterceptor();
withDevelopmentConsentCookie();
withFetchInterceptor();

function MyApp({ Component, pageProps, ...props }: AppProps) {
  initAllerUserConsentQueue();
  useUserMigration();

  const isPreviewPage = props.router.route.includes('/_preview');

  return (
    <StateProviders {...pageProps}>
      <GridOverlay />
      {!isPreviewPage && (
        <>
          <Consent />
          <EmbedLogin />
          <Tracking {...(pageProps.analyticsData ?? {})} />
        </>
      )}
      <div id="modal" />
      <Edge>{with410(<Component {...pageProps} />, pageProps)}</Edge>
    </StateProviders>
  );
}

export default MyApp;
